import types from './types';

const setUser = (user) => ({
    type: types.SET_USER,
    payload: user
});

const setExports = (exports) => ({
    type: types.SET_EXPORTS,
    payload: exports
});

const setLoading = (loading) => ({
    type: types.SET_LOADING,
    payload: loading
});

const setCredits = (credits) => ({
    type: types.SET_CREDITS,
    payload: credits
});

const setSettings = (settings) => ({
    type: types.SET_SETTINGS,
    payload: settings
});

const resetUserInfo = () => ({ type: types.RESET_USER_INFO });

export default {
    setUser,
    setExports,
    setLoading,
    setCredits,
    setSettings,
    resetUserInfo
};
